import React from "react";
import { FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { LookupSelect } from "@/components/lookupSelect";
import type { LookupFieldSchema, RowState } from "@/components/advanceSearch/types";

interface Props {
  row: RowState;
  control: any;
  onClear: (which: "value" | "value2") => void;
  fieldSchema?: LookupFieldSchema;
  dropdownPortalId?: string;
}

export const ConditionLookupInput: React.FC<Props> = ({
  row,
  control,
  onClear,
  fieldSchema,
  dropdownPortalId
}) => (
  <FormField
    control={control}
    name={`value_${row.id}` as const}
    rules={{ required: "This field is required." }}
    render={({ field, fieldState }) => {
      const value = Array.isArray(field.value) ? field.value : [];

      const handleChange = (tags: string[]) => {
        field.onChange(tags);
      };

      const handleClear = () => {
        field.onChange([]);
        onClear("value");
      };

      return (
        <FormItem className="relative w-full overflow-x-hidden">
          <FormControl>
            <LookupSelect
              value={value}
              onChange={handleChange}
              onClear={handleClear}
              error={Boolean(fieldState.error)}
              placeholder={fieldSchema?.placeholder}
              maxTags={fieldSchema?.maxTags}
              fetchSuggestions={fieldSchema?.fetchSuggestions}
              suggestionDebounce={fieldSchema?.suggestionDebounce}
              noOptionsMessage={fieldSchema?.noOptionsMessage}
              loadingMessage={fieldSchema?.loadingMessage}
              dropdownPortalId={dropdownPortalId}
            />
          </FormControl>
          <FormMessage className={"absolute left-0 top-full mt-1 text-xs text-red-600"} />
        </FormItem>
      );
    }}
  />
);
